// import { createSelector } from 'reselect';
import { getBodyData, getWidgetsData } from 'store/selectors';

const getBodyBlocks = (state) => getBodyData(state).blocks || {};
const getBodySubscribeFormBlock = (state) => getBodyBlocks(state).subscribeForm || {};
/* Selector for, probably, subscribe method or/and GTM */
export const getBodyRequestUrl = (state) => getBodyData(state).requestUrl || '';

export const getSubscribeFormHeading = (state) => getBodySubscribeFormBlock(state).headline || '';
export const getSubscribeFormHeadlineTagName = (state) =>
  getBodySubscribeFormBlock(state).headlineTagName || '';

export const getSubscribeFormWidgetData = (state) => getWidgetsData(state).SubscribeForm || {};

export const getSubscribeErrorFieldRequired = (state) =>
  getSubscribeFormWidgetData(state).requiredMessage || '';
export const getSubscribeErrorEmailInvalid = (state) =>
  getSubscribeFormWidgetData(state).invalidMessage || '';
/* Selectors for data agreement */
export const getSubscribeFormAgreementDataUrl = (state) =>
  getSubscribeFormWidgetData(state).agreementDataUrl || '';
export const getSubscribeFormAgreementUncheckedState = (state, id) => {
  if (getSubscribeFormWidgetData(state)?.agreementUncheckedState) {
    return !!getSubscribeFormWidgetData(state)?.agreementUncheckedState[id];
  }
};
